import React from "react";
import Navbar from "../../Navbar/Navbar";
import ModelAuditLog from "./ModelAuditLog";
import FillDetailAuditLog from "./FillDetailAuditLog";
import ScroollTableAuditLog from "./ScroollTableAuditLog";
import { ProductConsumer } from "../../Context/AddProWakel";
import "../shared/rtl-panel.css";

class AllAuditLogPage extends React.Component {
    render() {
        return (
            <div>
                <Navbar />
                <ProductConsumer>
                    {(value) => <AuditLogBody value={value} />}
                </ProductConsumer>
                <ModelAuditLog />
            </div>
        );
    }
}

class AuditLogBody extends React.Component {
    componentDidMount() {
        this.props.value.AL_getLogs();
    }

    render() {
        return (
            <div className="rs-page" dir="rtl">
                <FillDetailAuditLog />
                <ScroollTableAuditLog />
            </div>
        );
    }
}

export default AllAuditLogPage;
